module.exports = __webpack_public_path__ + "static/media/city.58a713c7.jpg";